/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module LogsModule */

import {
    Component,
    Input,
    OnInit,
} from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';

import { wafLatencyPhases } from 'ng/modules/logs/constants/logs-signpost.constants';

import { getWafLatencyRequestParams } from 'ng/modules/logs/utils/logs-signpost.utils';
import { addPoolIdFilterParams } from 'ng/modules/logs/utils/logs.utils';
import { TrafficLogsSignpostStore } from '../../../traffic-logs/traffic-logs-sidebar/traffic-logs-signpost.store';
import './logs-signpost-custom-waf-latency.component.less';
import * as l10n from './logs-signpost-custom-waf-latency.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Signpost component for WAF Latency section.
 * @author Suraj Kumar, Yogesh Patil
 */
@Component({
    selector: 'logs-signpost-custom-waf-latency',
    templateUrl: './logs-signpost-custom-waf-latency.component.html',
})
export class LogsSignpostCustomWafLatencyComponent implements OnInit {
    /**
     * The ID of the pool used to filter logs from a VS.
     */
    @Input()
    public poolId?: string;

    public readonly wafLatencyPhases = wafLatencyPhases;

    public readonly l10nKeys = l10nKeys;

    constructor(
        public readonly trafficLogsSignpostStore: TrafficLogsSignpostStore,
        l10nService: L10nService,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }

    /** @override */
    public ngOnInit(): void {
        const fullSignpostParams = getWafLatencyRequestParams();

        fullSignpostParams.forEach(param => {
            addPoolIdFilterParams(param.requestParams, this.poolId);
        });

        this.trafficLogsSignpostStore.getLogSignpostCombinedData(fullSignpostParams);
    }

    /**
     * Callback to ngFor-track by.
     */
    public trackbyIndex(index: number): number {
        return index;
    }
}
